var _g, _g2, _g3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeleteAccountIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 65,
    viewBox: "0 0 81 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_17581_36180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.0254 19.3492C78.3312 19.3492 81 16.7107 81 13.4656C81 10.2205 78.3312 7.58197 75.0254 7.58197C74.5402 7.58197 74.0549 7.64262 73.6 7.76393L73.0844 7.88525L73.0238 7.36967C72.5992 3.18443 69.0205 0 64.7443 0C61.4689 0 58.4664 1.91066 57.132 4.85246L57.0107 5.09508L56.7377 5.12541C54.6148 5.24672 52.7648 6.67213 52.1279 8.64345L51.9762 9.09836L51.5213 8.91639C50.8844 8.67377 50.1869 8.52213 49.4894 8.52213C46.4566 8.52213 44 10.9484 44 13.9205C44 16.8016 46.3049 19.1672 49.2164 19.3188H49.368H75.0254V19.3492Z",
    fill: "url(#paint0_linear_17581_36180)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_17581_36180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68 29C68 14.7419 56.2581 3 42 3C27.6371 3 16 14.7419 16 29C16 43.3629 27.6371 55 42 55C56.2581 55 68 43.3629 68 29ZM42 34.2419C44.621 34.2419 46.8226 36.4435 46.8226 39.0645C46.8226 41.7903 44.621 43.8871 42 43.8871C39.2742 43.8871 37.1774 41.7903 37.1774 39.0645C37.1774 36.4435 39.2742 34.2419 42 34.2419ZM37.3871 16.9435C37.2823 16.2097 37.9113 15.5806 38.6452 15.5806H45.25C45.9839 15.5806 46.6129 16.2097 46.5081 16.9435L45.7742 31.2016C45.6694 31.9355 45.1452 32.3548 44.5161 32.3548H39.379C38.75 32.3548 38.2258 31.9355 38.121 31.2016L37.3871 16.9435Z",
    fill: "#FA6F50"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_b_17581_36180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.17944 62.7805C3.20706 62.7805 0 59.6099 0 55.7104C0 51.8109 3.20706 48.6403 7.17944 48.6403C7.76254 48.6403 8.34565 48.7132 8.89231 48.8589L9.51186 49.0047L9.58474 48.3852C10.095 43.3559 14.3953 39.5293 19.5339 39.5293C23.4699 39.5293 27.0778 41.8253 28.6813 45.3603L28.8271 45.6519L29.1551 45.6883C31.7062 45.8341 33.9293 47.547 34.6946 49.9158L34.8768 50.4625L35.4235 50.2438C36.1888 49.9523 37.027 49.77 37.8652 49.77C41.5096 49.77 44.4615 52.6855 44.4615 56.257C44.4615 59.7192 41.6918 62.5618 38.1932 62.7441H38.011H7.17944V62.7805Z",
    fill: "url(#paint1_linear_17581_36180)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_17581_36180",
    x: 38,
    y: -6,
    width: 49,
    height: 31.3491,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_17581_36180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_17581_36180",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_17581_36180",
    x: 10,
    y: 1,
    width: 64,
    height: 64,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.600747 0 0 0 0 0.597361 0 0 0 0 0.766667 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_17581_36180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_17581_36180",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_b_17581_36180",
    x: -6,
    y: 33.5293,
    width: 56.4615,
    height: 35.251,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_17581_36180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_17581_36180",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_17581_36180",
    x1: 62.5,
    y1: 0,
    x2: 62.5,
    y2: 19.3492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0708332,
    stopColor: "#F3E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.451042,
    stopColor: "white",
    stopOpacity: 0.71
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE1B5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_17581_36180",
    x1: 22.2308,
    y1: 39.5293,
    x2: 22.2308,
    y2: 62.7805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0708332,
    stopColor: "#F3E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.451042,
    stopColor: "white",
    stopOpacity: 0.71
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE1B5",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteAccountIcon);
export default __webpack_public_path__ + "static/media/DeleteAccountIcon.f055dd37.svg";
export { ForwardRef as ReactComponent };